export default __webpack_public_path__ + "static/media/portfolio.34d88555.png";